import { useState, useEffect } from 'react';
import { PlaylistSong } from '../../../types/PlaylistTypes';
import { fetchSongsForSearch } from '../utils/playlistApi';

export const useSongSearch = () => {
    const [songs, setSongs] = useState<PlaylistSong[]>([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const loadSongs = async () => {
            try {
                setIsLoading(true);
                setError(null);
                const data = await fetchSongsForSearch();
                setSongs(data);
            } catch (err) {
                console.error("Error fetching songs for search:", err);
                setError(err instanceof Error ? err.message : "Failed to load songs");
            } finally {
                setIsLoading(false);
            }
        };

        loadSongs();
    }, []);

    return { songs, isLoading, error };
}; 